import React, { Component } from 'react';
import isContractInitialized from '../../utils/ContractInitializationState';
import LoadingAnimation from '../Components/LoadingAnimation';
import {
  addTransactionInProgress,
  transactionErrorHandler,
  transactionReceiptHandler
} from '../../utils/TransactionStateHelper';
import { TX_ERROR_OWNER_CREATE_COUPON, TX_OWNER_CREATE_COUPON } from '../../utils/TransactionTypes';

export default class OwnerCreateCoupon extends Component {
  constructor (props) {
    super(props);

    this.state = {
      couponName: '',
      coinsReward: '',
      timeCouponCanBeUsed: '',
      contractLoaded: false
    };

    this.storageUnsubscribe = null;
  }

  componentDidMount () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(() => this.isContractLoaded());
  }

  isContractLoaded () {
    isContractInitialized() && !this.state.contractLoaded && this.init();
  }

  componentWillUnmount () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  init () {
    this.storageUnsubscribe && this.storageUnsubscribe();
    this.setState({contractLoaded: true});
  }

  handleCouponNameChange = (event) => {
    this.setState({
      couponName: event.target.value
    });
  };

  handleCoinsRewardChange = (event) => {
    this.setState({
      coinsReward: +event.target.value || ''
    });
  };

  handleTimeCanBeUsedChange = (event) => {
    this.setState({
      timeCouponCanBeUsed: +event.target.value || ''
    });
  };

  handleCreatingCoupon = (event) => {
    // We don't want normal page submit
    event.preventDefault();

    if (this.state.couponName === '') {
      window.notifications.showError('Coupon name is empty.');

      return;
    }

    if (this.state.coinsReward <= 0) {
      window.notifications.showError('Coin reward is empty.');

      return;
    }

    window.contract
      .methods
      .createCoupon(this.state.couponName, this.state.coinsReward, this.state.timeCouponCanBeUsed)
      .send({from: Storage.getState().account.currentAccount, gasPrice: 0})
      .on('transactionHash',
        hash => addTransactionInProgress(hash, TX_OWNER_CREATE_COUPON, TX_ERROR_OWNER_CREATE_COUPON))
      .on('receipt', (receipt) => transactionReceiptHandler(receipt, () => {
        this.setState({
          couponName: '',
          coinsReward: '',
          timeCouponCanBeUsed: ''
        });

        window.notifications.showSuccess('Coupon was successfully created.');
      }))
      .on('error', (err, receipt) => transactionErrorHandler(err, receipt));
  };

  renderForm () {
    if (!this.state.contractLoaded) {
      return (<LoadingAnimation/>);
    }

    return (
      <form onSubmit={this.handleCreatingCoupon}>
        <div className="c-form-row">
          <label>Coupon name</label>
          <input type="text" placeholder="Coupon name" name="couponName" value={this.state.couponName}
                 onChange={this.handleCouponNameChange}/>
        </div>
        <div className="c-form-row">
          <label>Coin reward</label>
          <input type="number" placeholder="Coin reward" name="coins" value={this.state.coinsReward}
                 onChange={this.handleCoinsRewardChange}/>
        </div>
        <div className="c-form-row">
          <label>How many times can Coupon be used</label>
          <input type="number" placeholder="How many times can Coupon be used" name="coins"
                 value={this.state.timeCouponCanBeUsed}
                 onChange={this.handleTimeCanBeUsedChange}/>
        </div>
        <div className="c-form-row">
          <input type="submit" value="Create coupon"/>
        </div>
      </form>

    );
  }

  render () {
    return (<div className="c-component c-create-coupon">
      <h2>Create coupon</h2>
      {this.renderForm()}
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/OwnerDashboardPage/OwnerCreateCoupon.js